import Error502 from '@/shared/publish/Homework/Error502';
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/publish/Homework/Error502')({
  component: RouteComponent,
})

function RouteComponent() {
  return <Error502 />
}
